import { useQuery } from "@tanstack/react-query";
import {
  getTasksByType,
  TasksByTypeParams,
} from "@coworker/apprestructured/src/task-management/services/tasks.service";
import { getTasksByTypeQueryKey } from "@coworker/apprestructured/src/task-management/services/queryKeyHelper";
import TaskState from "@coworker/apprestructured/src/task-management/types/TaskState";

/**
 * Fetches all tasks matching the given type, store and state from tasks-v2.
 *
 * The query key is nested under TASKS_V2_QUERY_KEY so it is automatically
 * invalidated whenever invalidateTaskQueries() is called (e.g. after task
 * creation in TaskCreatorSheet).
 *
 * Backend requirement: GET /tasks-v2?task_type_id=:id&store_id=:id&state=:state
 */
export function useTasksByType(
  taskTypeId: string | null | undefined,
  storeId: string | null | undefined,
  state: TaskState | null | undefined
) {
  return useQuery({
    queryKey: getTasksByTypeQueryKey(taskTypeId, storeId, state),
    queryFn: () =>
      getTasksByType({
        taskTypeId: taskTypeId!,
        storeId: storeId!,
        state: state!,
      } satisfies TasksByTypeParams),
    enabled: !!taskTypeId && !!storeId && !!state,
    staleTime: 0,
  });
}
